<template>
  <InputFieldForm
    :id="id"
    :label="label"
    :required="isFieldRequired(validationRules)"
    :validation-message="errors[0]"
  >
    <textarea
      :id="id"
      v-model="value"
      class="form-control"
      :aria-invalid="errors[0] ? errors[0] : undefined"
      :aria-describedby="validationSpanId"
      v-bind="$attrs"
    />
  </InputFieldForm>
</template>

<script lang="ts" setup>
import InputFieldForm from '@/VueComponents/SharedComponents/InputFields/InputFieldForm.vue';
import InputFieldElementIdGenerator from '@/VueComponents/SharedComponents/InputFields/utils/inputFieldElementIdGenerator';
import { useField } from 'vee-validate';
import { DtoValidatorRule, createValidator, isFieldRequired } from '@/Validation/dtoVeeValidator';

const props = withDefaults(defineProps<{
  id: string,
  label?: string,
  validationRules?: DtoValidatorRule[]
}>(), { required: false, label: undefined, validationMessage: undefined, validationRules: undefined });

if (!props.id) {
  console.error(`Unique 'id' should be provided.`);
}

const validationSpanId = InputFieldElementIdGenerator.getValidationMessageId(props.id);

const { errors, value, validate } = useField(props.id ?? '', createValidator(props.validationRules));

async function isValid() {
  const result = await validate();
  return result.valid;
}

defineExpose({
  isValid
});
</script>
